const fallback = (text: string) => {
  return new Promise<void>((resolve, reject) => {
    const input = window.document.createElement('input')
    document.body.appendChild(input)
    input.value = text
    input.style.width = '1px'
    input.style.height = '1px'
    input.focus()
    input.select()
    try {
      if (document.execCommand('copy')) {
        resolve()
      } else {
        reject()
      }
    } catch (error) {
      reject(error)
    } finally {
      document.body.removeChild(input)
    }
  })
}
const copyToClipboard = (text: string) =>
  (navigator.clipboard
    ? navigator.clipboard.writeText(text).catch(() => fallback(text))
    : fallback(text)
  ).catch(() => {
    window.prompt('Please hit Ctrl+C to copy to clipboard', text)
  })

export default copyToClipboard
